import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Typography.module.scss';

const Typography = ({
  type = 'text-md',
  element: Element = 'div',
  color = 'dark',
  weight,
  align,
  uppercase,
  children,
  className,
  ...props
}) => (
  <Element
    className={classNames(
      styles[type],
      styles[`color-${color}`],
      styles[`weight-${weight}`],
      styles[`align-${align}`],
      {
        [styles.uppercase]: uppercase,
      },
      className,
    )}
    data-testid="typography-root"
    {...props}
  >
    {children}
  </Element>
);

Typography.propTypes = {
  type: PropTypes.oneOf([
    'heading-lg',
    'heading-md',
    'heading-sm',
    'text-lg',
    'text-md',
    'text-sm',
    'text-xs',
  ]),
  element: PropTypes.oneOf([
    'div',
    'span',
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
  ]),
  color: PropTypes.oneOf([
    'dark',
    'white',
    'grey',
    'lightGrey',
    'blue',
    'yellow',
    'green',
    'purple',
    'inherit',
  ]),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  uppercase: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default memo(Typography);
